import { useParams } from 'react-router-dom';

const useTypedParams = () => useParams<{ id?: string }>();
export default useTypedParams;
